import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'myt-react-notify/template.css';
import './layout.css'
import './index.css'

if(process.env.NODE_ENV === 'production')
    console.log = () => {}
    
const root = document.getElementById('mytabworks')

if(root.hasChildNodes()) {
    ReactDOM.hydrate(<App />, root);
} else {
    ReactDOM.render(<App />, root);
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
if(process.env.NODE_ENV === 'production') {
    serviceWorker.register({
        onUpdate: registration => {
            alert('New version available!  Ready to update?');
            window.location.reload();
            if (registration && registration.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            }
        }
    });
} else {
    serviceWorker.unregister();
}
